import { Alert, CircularProgress } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import {
  useGetMaterialPhysicsSetQuery,
  useGetMaterialMetadataSetQuery,
} from "store/api/generatedApi";
import { MaterialPhysicsDefaultsEditor } from "./MaterialPhysicsDefaultsEditor";

export const MaterialPhysicsDefaultParameters = ({
  isActive,
  setConfirmOpen,
}: {
  isActive: boolean;
  setConfirmOpen: (open: boolean) => void;
}) => {
  const tenantName = useTenant();
  const { t } = useTenantTranslation();
  const physics = useGetMaterialPhysicsSetQuery({
    tenantName,
    materialPhysicsSetId: "default",
  });
  const materials = useGetMaterialMetadataSetQuery({
    tenantName,
    materialMetadataSetId: "default",
  });
  if (
    (physics.isError && !physics.currentData) ||
    (materials.isError && !materials.currentData)
  )
    return <Alert severity="error">{t("errorLoadingData")}</Alert>;
  if (!physics.currentData || !materials.currentData)
    return <CircularProgress />;
  return (
    <MaterialPhysicsDefaultsEditor
      key={tenantName}
      isActive={isActive}
      setConfirmOpen={setConfirmOpen}
      defaultSet={physics.currentData}
      materials={materials.currentData.materials}
      refresh={physics.refetch}
    />
  );
};
